import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'gatsby-plugin-react-i18next'

const MenuItem = (props) => {
    return (
        <Link className="navbar-item" to={props.href}>
            {props.title}
        </Link>
    )
}

MenuItem.propTypes = {
    title: PropTypes.string.isRequired,
    href: PropTypes.string,
}

MenuItem.defaultProps = {
    href: '#',
}

export default MenuItem
